module.exports = __webpack_public_path__ + "assets/img/fire.cfa4282d.svg";